// The sidebar's member hover draws the member (or its role's range, or a SPOT point)
// here. An overlay like the other hover layers (zIndex 100), cleared on map click.
// A crosslink member gets a wide halo instead: added before the crosslink hover
// layer, so the ribbon's own colours stay on top with orange either side.
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import { Circle as CircleStyle, Fill, Stroke, Style } from "ol/style";

const MEMBER_HOVER_COLOR = "#ff8f00";

const lineStyle = [
  new Style({ stroke: new Stroke({ color: "white", width: 11 }) }),
  new Style({ stroke: new Stroke({ color: MEMBER_HOVER_COLOR, width: 7 }) }),
];
// Light and narrow: 2px of soft orange either side of the ribbon's 7px line.
const haloStyle = new Style({
  stroke: new Stroke({ color: "rgba(255, 143, 0, 0.45)", width: 11 }),
});
const pointStyle = new Style({
  image: new CircleStyle({
    radius: 7,
    fill: new Fill({ color: MEMBER_HOVER_COLOR }),
    stroke: new Stroke({ color: "white", width: 2 }),
  }),
});

export function addMemberHoverLayer(map) {
  const source = new VectorSource({});
  const layer = new VectorLayer({
    source,
    style: (feature) => {
      if (feature.getGeometry().getType() === "Point") return pointStyle;
      return feature.get("halo") ? haloStyle : lineStyle;
    },
  });
  layer.setZIndex(100);
  map.addLayer(layer);
  map.on("click", () => source.clear());
  return layer;
}
